import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import TeaCard from './TeaCard';
import { Product, useAnimationConfig } from '../../hooks';
import { LoadingState } from '../common/state/LoadingComponents';

interface ProductGridProps {
  products: Product[];
  loading: boolean;
  error: string | null;
}

const ProductGrid: React.FC<ProductGridProps> = ({ products, loading, error }) => {
  const { containerVariants, productVariants, productGridTransition } = useAnimationConfig();

  if (loading) {
    return (
      <LoadingState skeleton skeletonType="grid" skeletonProps={{ items: 8, columns: 4 }} />
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-500 py-12">
        <p className="text-lg">{error}</p>
        <p className="text-sm mt-2">Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center text-gray-500 py-12">
        <p className="text-lg">Bu kategoride ürün bulunamadı.</p>
        <p className="text-sm mt-2">Farklı bir kategori seçmeyi deneyin.</p>
      </div>
    );
  }

  return (
    <motion.div
      layout
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
      variants={containerVariants}
      initial="initial"
      animate="animate"
    >
      <AnimatePresence mode="popLayout">
        {products.map(product => (
          <motion.div
            key={product.id}
            layout
            variants={productVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={productGridTransition}
          >
            <TeaCard product={product} />
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

export default ProductGrid;
